import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { totalUnreadSelector } from 'lib-trend-core/chat';
import { distinctUntilChanged } from 'rxjs/operators';

/**
 * Unread total on the installed app's icon — SPEC-2026-09-internal-chat-pwa (T-35 ·
 * RF-17). Fed by the same store total the rail shows; the messaging worker updates it
 * from the push payload while the app is closed. Feature-detected: platforms without the
 * Badging API simply show no badge.
 */
@Injectable({ providedIn: 'root' })
export class ChatAppBadgeService {

  private started = false;

  constructor(private readonly store: Store) { }

  start(): void {
    const nav = navigator as Navigator & {
      setAppBadge?: (contents?: number) => Promise<void>;
      clearAppBadge?: () => Promise<void>;
    };
    if (this.started || typeof nav.setAppBadge !== 'function') return;
    this.started = true;

    this.store.select(totalUnreadSelector)
      .pipe(distinctUntilChanged())
      .subscribe((total) => {
        const update = total > 0 ? nav.setAppBadge?.(total) : nav.clearAppBadge?.();
        update?.catch(() => { /* permission or platform refusal */ });
      });
  }
}
